import { createMultiSelectOptionSetValueFromOptionGuid, FieldsToLookupByMasterAttributeId, friendlyTValue } from "global/Application";
import * as FAM from "model/FlexibleAttributeModel";
import { v4 as uuidv4 } from 'uuid';
import { Memoize } from "../Utility/TSFunctions";
import { BaseJsonTransformer } from "./IJsonTransformer";

interface IMapping {

    [key: string]: {
        description: string;
        categories: {
            id: string;
            description: string;
        }[];
    };
}

/**
 * Transformers:
 * Moved from Sprint34Transformer.ts
 * MHTK And NIA programs transformer - old optionset to multi select fields
 * https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2032?workitem=488342
 */
export class Sprint33PatchTransformer extends BaseJsonTransformer {
    config: FAM.IGroupConfigurationConfig;
    json: FAM.IGroupConfigurationData;

    addNotificationNIAMultiSelect: boolean = false;

    constructor({ config, json }: { config: FAM.IGroupConfigurationConfig, json: FAM.IGroupConfigurationData }) {
        super();
        this.config = config;

        this.json = json;

    }

    MHTKMapping() {

        // Define a mapping object
        const myHealthNovelGuidMappings: { [key: string]: string } = {
            "Weight Management Program": "d37097f8-1454-ef11-a317-000d3a17460e",
            "Behavioral Health": "840d6ea6-1454-ef11-a317-000d3a17460e",
            "Digestive Health": "59f593b9-1454-ef11-a317-000d3a17460e",
            "Musculoskeletal": "36ef15c6-1454-ef11-a317-000d3a17460e",
            "No": "9fb6b8d8-1454-ef11-a317-000d3a17460e",
            "Tobacco Cessation": "c69d27e5-1454-ef11-a317-000d3a17460e",
            "Women's Health": "7c5da904-1554-ef11-a317-000d3a17460e"
        };

        const myHealthNovelValueMappings: { [key: string]: number } = {
            "Weight Management Program": 10,
            "Behavioral Health": 20,
            "Digestive Health": 30,
            "Musculoskeletal": 40,
            "No": 50,
            "Tobacco Cessation": 60,
            "Women's Health": 70
        };

        // Define a mapping object
        const niaGuidMappings: IMapping =
        {
            "b64cb1a5-8e12-ed11-b83b-000d3a3725d8": {
                "description": "Hips Knees and Shoulders",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    }
                ]
            },
            "b84cb1a5-8e12-ed11-b83b-000d3a3725d8": {
                "description": "Hips Knees and Shoulders and Musculoskeletal Care",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    }
                ]
            },
            "ba4cb1a5-8e12-ed11-b83b-000d3a3725d8": {
                "description": "Hips Knees and Shoulders and Radiation Oncology",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    }
                ]
            },
            "bc4cb1a5-8e12-ed11-b83b-000d3a3725d8": {
                "description": "Hips Knees and Shoulders and Radiology Management",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            },
            "be4cb1a5-8e12-ed11-b83b-000d3a3725d8": {
                "description": "Hips Knees and Shoulders, Musculoskeletal Care and Radiation Oncology",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    }
                ]
            },
            "c04cb1a5-8e12-ed11-b83b-000d3a3725d8": {
                "description": "Hips Knees and Shoulders, Musculoskeletal Care, Radiation Oncology and Radiology Management",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    },
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            },
            "97adc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "No",
                "categories": [
                    {
                        "id": "8df1de3a-1954-ef11-a317-000d3a17460e",
                        "description": "No"
                    }
                ]
            },
            "99adc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Musculoskeletal Care",
                "categories": [
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    }
                ]
            },
            "9badc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Radiation Oncology",
                "categories": [
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    }
                ]
            },
            "9dadc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Radiology Management",
                "categories": [
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            },
            "9fadc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Musculoskeletal Care and Radiology Management",
                "categories": [
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            },
            "a1adc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Musculoskeletal Care and Radiation Oncology",
                "categories": [
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    }
                ]
            },
            "a3adc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Radiation Oncology and Radiology Management",
                "categories": [
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    },
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            },
            "a5adc8fa-e358-ec11-8f8f-000d3a597a8a": {
                "description": "Musculoskeletal Care, Radiation Oncology and Radiology Management",
                "categories": [
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": "3f9a4822-1954-ef11-a317-000d3a17460e",
                        "description": "Radiation Oncology"
                    },
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            },
            "b72d860f-d239-ed11-9db0-000d3a998139": {
                "description": "Hips Knees and Shoulders, Musculoskeletal Care and Radiology Management",
                "categories": [
                    {
                        "id": "879382b5-1854-ef11-a317-000d3a17460e",
                        "description": "Hips Knees and Shoulders"
                    },
                    {
                        "id": "a49c5e14-1954-ef11-a317-000d3a17460e",
                        "description": "Musculoskeletal Care"
                    },
                    {
                        "id": "f580b72e-1954-ef11-a317-000d3a17460e",
                        "description": "Radiology Management"
                    }
                ]
            }
        };

        const niaValueMappings: { [key: string]: number } = {
            "Hips Knees and Shoulders": 10,
            "Musculoskeletal Care": 20,
            "No": 50,
            "Radiation Oncology": 30,
            "Radiology Management": 40
        };
        return {
            myHealthNovelGuidMappings,
            myHealthNovelValueMappings,
            niaGuidMappings,
            niaValueMappings
        }
    }

    async before(json: FAM.IGroupConfigurationData): Promise<void> {

    }

    async transformBenefit(benefit: FAM.IBenefit): Promise<boolean | void> {

        const categories = this.config.cache.map_bcbs_config_category_named;

        // cache list of fields upon first call
        const fieldInfosMemoized = Memoize(() => {
            return FieldsToLookupByMasterAttributeId(this.config, benefit.fields);
        });

        // --------------------------------------------------------------------------------------------
        // is Ancillary benefit?
        if (benefit.bcbs_config_categoryid === this.config.cache.map_bcbs_config_category_named['Ancillary'].bcbs_config_categoryid) {

            // map to array of master attributes, first element in array being the visible one.
            const fieldsByMasterAttrId = fieldInfosMemoized();

            //myHealthNovel - optionSet (original)
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1998f1ab-3d58-ec11-8f8f-000d3a597a8a
            const bcbs_myhealthnovel_masterAttribute_old = fieldsByMasterAttrId['1998f1ab-3d58-ec11-8f8f-000d3a597a8a']
            const bcbs_myhealthnovel_old = bcbs_myhealthnovel_masterAttribute_old[0];

            //MyHealthNovel - multiselect
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1a953404-1354-ef11-a317-000d3a17460e            
            const bcbs_myhealthnovel_masterAttribute = fieldsByMasterAttrId['1a953404-1354-ef11-a317-000d3a17460e']
            const bcbs_myhealthnovel = bcbs_myhealthnovel_masterAttribute[0];

            //NIA Programs - OptionSet
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2598f1ab-3d58-ec11-8f8f-000d3a597a8a
            const bcbs_niaPrograms_masterattribiute_old = fieldsByMasterAttrId['2598f1ab-3d58-ec11-8f8f-000d3a597a8a']
            const bcbs_niaprograms_old = bcbs_niaPrograms_masterattribiute_old[0];

            //NIA Programs - multiSelect
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=0803c40e-1754-ef11-a317-000d3a17460e
            const bcbs_niaPrograms_masterattribiute = fieldsByMasterAttrId['0803c40e-1754-ef11-a317-000d3a17460e']
            const bcbs_niaprograms = bcbs_niaPrograms_masterattribiute[0];

            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/516942
            // update new field if the old field is populated
            if (bcbs_myhealthnovel_old) {

                //if old field exists and new field does not have a value, get the value
                const value_bcbs_myhealthnovel_old = bcbs_myhealthnovel_old.field.values[0];
                const value_bcbs_myhealthnovel = bcbs_myhealthnovel.field.values[0];
                //need to parse out the values from the old optionset
                if (value_bcbs_myhealthnovel_old.value && !value_bcbs_myhealthnovel.value) {
                    const stringValue_myhealthnovel = friendlyTValue(value_bcbs_myhealthnovel_old.value);
                    var listOfMyHealthNovelValues = stringValue_myhealthnovel.split(' + ');

                    var listOfGuids: string[] = [];
                    //build list of guids
                    listOfMyHealthNovelValues.forEach(mhnValue => {
                        if (this.MHTKMapping().myHealthNovelGuidMappings[mhnValue] !== undefined) {
                            listOfGuids.push(this.MHTKMapping().myHealthNovelGuidMappings[mhnValue]);
                        }
                    });

                    bcbs_myhealthnovel.field.values[0].value = createMultiSelectOptionSetValueFromOptionGuid(this.config, listOfGuids);
                }
            }

            if (bcbs_niaprograms_old) {

                //if old field exists and new field does not have a value, get the value
                const value_nia_oldID = bcbs_niaprograms_old.field.values[0].value?.type === "entity" ? bcbs_niaprograms_old.field.values[0].value.id : "";
                const value_bcbs_nia = bcbs_niaprograms.field.values[0];
                if (value_nia_oldID && !value_bcbs_nia.value) {
                    //need to parse out the values from the old optionset
                    var listOfNIAValues = this.MHTKMapping().niaGuidMappings[value_nia_oldID];

                    var listOfGuids: string[] = [];
                    //build list of guids
                    listOfNIAValues.categories.forEach(niaCategory => {
                        listOfGuids.push(niaCategory.id);
                    });

                    bcbs_niaprograms.field.values[0].value = createMultiSelectOptionSetValueFromOptionGuid(this.config, listOfGuids);
                }
            }

            //option set -> carrier lookup transformer 
        }
    }

    async after(json: FAM.IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint33PatchTransformer.after")

        if (!json.transformers)
            json.transformers = {};

        json.transformers.Sprint33PatchTransformer = true

    }
}
